module.exports = __webpack_public_path__ + "static/media/ggg_1.9a775d65.jpg";